var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.828,
    height: 103.828,
    viewBox: "0 0 103.828 103.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(-42.667 -42.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22184",
    "data-name": "Path 22184",
    d: "M141.3,42.667H47.858a5.191,5.191,0,0,0-5.191,5.191V141.3a5.191,5.191,0,0,0,5.191,5.191H141.3a5.191,5.191,0,0,0,5.191-5.191V47.858a5.191,5.191,0,0,0-5.191-5.191Zm-5.191,93.445H53.05V53.05h83.063Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22185",
    "data-name": "Path 22185",
    d: "M161.9,177.993a20.941,20.941,0,1,0-6.489,8.1l10.383,8.254a5.191,5.191,0,1,0,6.489-8.1Zm-18.9,1.921a10.383,10.383,0,1,1,7.342-3.041A10.382,10.382,0,0,1,143.007,179.914Zm-31.148-41.531h5.191a5.191,5.191,0,1,0,0-10.383h-5.191a5.191,5.191,0,0,0,0,10.383Zm20.766,0h41.531a5.191,5.191,0,1,0,0-10.383H132.624a5.191,5.191,0,0,0,0,10.383Z",
    transform: "translate(-48.426 -64.568)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.03b10594808e1ee05e563b03053397b6.svg";
export { ForwardRef as ReactComponent };